import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { salesReturnDetailsDto } from './sales_return_details';

export interface SalesReturnParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface SalesReturn {
    taxType:string;
    id?:any;
    phBillRtnNo:any;
    phBillRtnDate:any;
    phBillId:any;
    phdoctorid:string;
    phBillRtnTotal:number;
    phGSTRtnTotal:number
    phRtnDiscounttype:string;
    phRoundofftpe:string;
    phRtnDiscountpercentage:number;
    phRtnDiscountamount: number;
    phRtnRoundoff: number;
    phRtnNettotal:number;
    phReceiptmode: string;
    phRtnReasonId: number;
    phRtnBillBywhom: string;
    phRtnBillCustomerId: number;
    pharmacyId:any;
    phRtnBillRegId:string;
    createdBy:any;
    phRtnBillAdmId:number;
    discountAfterTax?:number;
    createdDate:any;
    branchId:string;
    tenantId:string;
    presType?:number;
    billType?:number;
    externalPhyId?:string;
    refId?:string;
    phSaleType:string;
    healthCardDisc?:number;
    healthCardId?:number;
        //New Column

    updatedBy: any;
    updatedDate: Date;
    updatedIP: string;
    createdIP: string;
    miscellaneousReturnFlag?:boolean;
    salesBillIds?:Array<any>;

    phBillRtnDet: salesReturnDetailsDto[];
    walletData: {
      packageId: string | null;
      deposit: number;
      narration: string;
      refType: string;
      createdBy: string;
      regId: string;
      tenantId: string;
      branchId: string;
  };
  paymentMst: {
      id?: string;
      branchId: string;
      paymentDate: Date;
      receiverType: string;
      deleteFlag: string;
      expenseType: string;
      supplierId: string | null;
      employeeId: string | null;
      expenseId: string;
      notes: string | null;
      othersName: string | null;
      othersAddress: string | null;
      othersPhone: string | null;
      expenseNo: string;
      netAmount: number;
      pharmacyId: string | null;
      physicianId: string | null;
      advanceId: string | null;
      tenantId: string;
      dpBillId: string | null;
      walletTransId: number;
      createdBy: string;
      createdDate: Date;
      updatedBy: number;
      updatedDate: Date;
      createdIp: string;
      updatedIp: string;
      paymentsDet:[ {
          id?: string;
          paymentId: string;
          referenceBank: number;
          referenceNo: string;
          createdBy: string;
          createdDate: Date;
          purchaseNo: string;
          billInvoiceNo: string;
          paymentType: string;
          cash: number;
          card: number;
          onlineTransfer: number;
          chequeDD: number;
          branchId: string;
          tenantId: string;
          cardType: string;
          upiPaymentId: string;
          checkNo: string;
          netBanking: number;
      }];
      alternatePhoneType: any;
      alternatePhoneNumber: any;
      paidAmount: number;
      cancelledBy: any;
      cancelledDate: any;
      cancelledReason: any;
      cancelledIP: any;
      cancelledFlag: any;
  };
    parameters?: SalesReturnParameter[];
    links?: any;
}
export interface DistinctReason{
  id:string;
  name:string;
}

export abstract class SalesReturnData {
    abstract getall(url: string): Observable<SalesReturn[]>;
    abstract getById(url: string): Observable<any>;
    abstract create(url: string, data: SalesReturn): Observable<SalesReturn[]>;
    abstract update(url: string, data: SalesReturn): Observable<SalesReturn>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract distinctReason(url:string):Observable<any>;

    //SalesReportForMultiBranch
    abstract searchForMultiBranch(url: string,data:any): Observable<any>;
}
